import { ReactNode } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button, { Props as ButtonProps } from 'components/button/Button';

interface ModalFormSubmitButtonProps
  extends Omit<ButtonProps, 'children' | 'type'> {
  children?: ReactNode;
  'data-testid'?: string;
}

const ModalFormSubmitButton = ({
  bsStyle,
  children,
  'data-testid': dataTestId,
  disabled,
  ...props
}: ModalFormSubmitButtonProps) => {
  const { t } = useTranslation();
  const { isDirty, isSubmitting } = useFormState();

  return (
    <Button
      bsStyle={bsStyle ?? 'primary'}
      data-testid={dataTestId ?? 'modal-form-submit-button'}
      disabled={!isDirty || (disabled ?? isSubmitting)}
      type="submit"
      {...props}
    >
      {children ?? t(isSubmitting ? 'common.saving' : 'common.save')}
    </Button>
  );
};

ModalFormSubmitButton.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

export default ModalFormSubmitButton;
